import "./VehiclesExportModal.scss";

import { useVehiclesExport } from "../../hooks/useVehiclesExport";

import { FileDownload } from "@mui/icons-material";

import { Button } from "../../common-components/Buttons/Buttons";

const VehiclesExportModal = () => {
    const { handleExport } = useVehiclesExport({componentId: "vehicles"});

    return (
        <div className={"vehicles-export-modal"}>
            <div className={"vehicles-export-modal_container"}>
                <div className={"vehicles-export-modal_icon"}>
                    <FileDownload sx={{fontSize: "60px"}}/>
                </div>
                <div className={"vehicles-export-modal_title"}>
                    {"Экспорт в Excel"}
                </div>
                <div className={"vehicles-export-modal_button"}>
                    <Button Icon={FileDownload} title={"Экспорт"} onClick={handleExport}/>
                </div>
            </div>
        </div>
    )
}

export default VehiclesExportModal;
